export class Third_Kinship {
    get id() {
        return this.thirdKinship.id;
    }
    get kinship() {
        return this.thirdKinship.kinship;
    }
    get name() {
        return this.thirdKinship.name;
    }
    get third_id() {
        return this.thirdKinship.third_id;
    }
    get third_relation() {
        return this.thirdKinship.third_relation;
    }
    get member() {
        return this.thirdKinship.member;
    }
    set id(id) {
        this.thirdKinship.id = id;
    }
    set kinship(kinship) {
        this.thirdKinship.kinship = kinship;
    }
    set name(name) {
        this.thirdKinship.name = name;
    }
    set third_id(third_id) {
        this.thirdKinship.third_id = third_id;
    }
    set third_relation(third_relation) {
        this.thirdKinship.third_relation = third_relation;
    }
    set member(member) {
        this.thirdKinship.member = member;
    }
    constructor(thirdKinship) {
        this.thirdKinship = thirdKinship;
    }
    getState() {
        return this.thirdKinship;
    }
}
